import { z } from 'zod';

export const propertyValidationSchema = z.object({
  title: z
    .string()
    .min(5, 'Title must be at least 5 characters long')
    .max(100, 'Title cannot exceed 100 characters'),
  description: z
    .string()
    .min(20, 'Description must be at least 20 characters long')
    .max(1000, 'Description cannot exceed 1000 characters')
    .optional()
    .or(z.literal('')),
  price: z
    .number({ invalid_type_error: 'Price must be a number' })
    .positive('Price must be a positive number')
    .min(1000, 'Price must be at least ₹1,000'),
  location: z
    .string()
    .min(3, 'Location must be at least 3 characters long')
    .max(100, 'Location cannot exceed 100 characters'),
  bedrooms: z
    .number({ invalid_type_error: 'Bedrooms must be a number' })
    .int('Bedrooms must be a whole number')
    .min(0, 'Bedrooms cannot be negative')
    .max(20, 'Bedrooms cannot exceed 20')
    .optional()
    .or(z.literal('')),
  bathrooms: z
    .number({ invalid_type_error: 'Bathrooms must be a number' })
    .int('Bathrooms must be a whole number')
    .min(0, 'Bathrooms cannot be negative')
    .max(20, 'Bathrooms cannot exceed 20')
    .optional()
    .or(z.literal('')),
  area: z
    .number({ invalid_type_error: 'Area must be a number' })
    .positive('Area must be a positive number')
    .min(100, 'Area must be at least 100 sq. ft.')
    .optional()
    .or(z.literal('')),
  property_type: z.enum(['house', 'apartment', 'condo', 'land', 'villa', 'studio', 'duplex', 'commercial']),
  status: z.enum(['available', 'pending', 'sold', 'rented']),
  amenities: z
    .string()
    .max(500, 'Amenities list cannot exceed 500 characters')
    .optional()
    .or(z.literal('')),
  address: z
    .string()
    .min(5, 'Address must be at least 5 characters long')
    .max(200, 'Address cannot exceed 200 characters'),
  city: z
    .string()
    .min(3, 'City must be at least 3 characters long')
    .max(100, 'City cannot exceed 100 characters'),
  state: z
    .string()
    .min(2, 'State must be at least 2 characters long')
    .max(100, 'State cannot exceed 100 characters'),
  parking: z
    .number({ invalid_type_error: 'Parking slots must be a number' })
    .int('Parking slots must be a whole number')
    .min(0, 'Parking slots cannot be negative')
    .max(10, 'Parking slots cannot exceed 10')
    .optional()
    .or(z.literal('')),
  year_built: z
    .number({ invalid_type_error: 'Year Built must be a number' })
    .int('Year Built must be a whole number')
    .min(1800, 'Year Built cannot be before 1800')
    .max(new Date().getFullYear(), `Year Built cannot be in the future (${new Date().getFullYear()})`)
    .optional()
    .or(z.literal('')),
  images: z
    .array(z.object({ url: z.string().url(), isLocal: z.boolean().optional(), file: z.any().optional(), name: z.string().optional() }))
    .min(1, 'At least one image is required')
    .max(10, 'You can upload a maximum of 10 images')
    .optional(),
  lat: z
    .number({ invalid_type_error: 'Latitude must be a number' })
    .min(-90, 'Latitude must be between -90 and 90')
    .max(90, 'Latitude must be between -90 and 90')
    .optional()
    .or(z.literal(null)), 
  lng: z
    .number({ invalid_type_error: 'Longitude must be a number' })
    .min(-180, 'Longitude must be between -180 and 180')
    .max(180, 'Longitude must be between -180 and 180')
    .optional()
    .or(z.literal(null)), 
});